import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FEATURE_FLAGS } from '../../config/featureFlags';
import { getTablesForRoute } from '../../config/adminPageTables';

const TableFooter = () => {
  const location = useLocation();
  const { user } = useAuth();
  
  // Check if feature is enabled
  if (!FEATURE_FLAGS.SHOW_ADMIN_TABLE_FOOTER) {
    return null;
  }
  
  // Only show for Master Admin
  if (!user || user.role !== 'master_admin') {
    return null;
  }
  
  // Get tables for current route
  const tables = getTablesForRoute(location.pathname);
  
  // Don't render if no tables found
  if (tables.length === 0) {
    return null;
  }
  
  return (
    <div className="mt-8 pt-4 border-t border-gray-200">
      <div className="text-xs text-gray-500">
        <span className="font-medium">Tables Used (Master Admin):</span>
        <ul className="mt-1 space-y-1">
          {tables.map((table, index) => (
            <li key={index} className="ml-4">
              • {table}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default TableFooter;
